import actionTypes from "../../actions/actionTypes"
import { call, put, select, takeEvery } from "redux-saga/effects"
import { OBJ_SELECTIONDISPLAY, OBJ_SELECTION, OBJ_COLLECTION, OBJ_PM_MOVIE, OBJ_META_MOVIE, OBJ_AD, OBJ_HIGLLIGHT, OBJ_PY_EXTENSION, OBJ_WEISCHER, OBJ_ADVERTISEMENT, OBJ_ELBENWALD_BRAND_MAPPINGS } from "../../constants/objectTypes"
import { ROUTER } from "../../constants/state"



const objTypesByUpdateAction = {
    [actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ITEM]:                OBJ_SELECTIONDISPLAY,
    [actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ITEM_ORDER]:          OBJ_SELECTIONDISPLAY,

    [actionTypes.ITEMSELECTIONS_ADD_ITEM]:                          OBJ_SELECTION,
    [actionTypes.ITEMSELECTIONS_UPDATE_ITEM_SETTINGS]:              OBJ_SELECTION,
    [actionTypes.ITEMSELECTIONS_UPDATE_ITEM_SHOWINAPP]:             OBJ_SELECTION,

    [actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_ITEMS]:                OBJ_COLLECTION,
    [actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_TRUE]:          OBJ_COLLECTION,
    [actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_FALSE]:         OBJ_COLLECTION,

    [actionTypes.PMMOVIES_UPDATE_ITEM_ORDER]:                       OBJ_PM_MOVIE,
    [actionTypes.PMMOVIES_UPDATE_ITEM_EDITABLE_ATTRIBUTES]:         OBJ_PM_MOVIE,
    
    [actionTypes.MOVIE_EXTENSIONS_UPDATE_ITEM]:                     OBJ_PY_EXTENSION,
    [actionTypes.MOVIE_EXTENSIONS_ADD_ITEM_TO_RESET]:               OBJ_PY_EXTENSION,

    [actionTypes.METAMOVIES_UPDATE_ITEM_ORIGIN]:                    OBJ_META_MOVIE,

    [actionTypes.ADS_ADD_ITEM]:                                     OBJ_AD,
    [actionTypes.ADS_UPDATE_ITEM]:                                  OBJ_AD,

    [actionTypes.HIGHLIGHTS_ADD_ITEM]:                              OBJ_HIGLLIGHT,
    [actionTypes.HIGHLIGHTS_UPDATE_ITEM]:                           OBJ_HIGLLIGHT,

    [actionTypes.WEISCHERAD_ADD_ITEM]:                              OBJ_WEISCHER,
    [actionTypes.WEISCHERAD_UPDATE_ITEM]:                           OBJ_WEISCHER,

    [actionTypes.ADVERTISEMENTS_ADD_ITEM]:                          OBJ_ADVERTISEMENT,
    [actionTypes.ADVERTISEMENTS_UPDATE_ITEM]:                       OBJ_ADVERTISEMENT,
    [actionTypes.ADVERTISEMENTS_UPDATE_ITEM_ORDER]:                 OBJ_ADVERTISEMENT,

    [actionTypes.BRAND_MOVIE_MAPPINGS_CREATE_ITEM]:                 OBJ_ELBENWALD_BRAND_MAPPINGS,       
}

const objTypesByDeleteAction = {
    [actionTypes.ITEMSELECTIONSDISPLAY_DELETE_ITEM]:                OBJ_SELECTIONDISPLAY,

    [actionTypes.ITEMSELECTIONS_DELETE_ITEM]:                       OBJ_SELECTION,

    [actionTypes.ITEMCOLLECTIONS_DELETE_ITEM]:                      OBJ_COLLECTION,

    [actionTypes.ADS_DELETE_ITEM]:                                  OBJ_AD,

    [actionTypes.HIGHLIGHTS_DELETE_ITEM]:                           OBJ_HIGLLIGHT,

    [actionTypes.WEISCHERAD_DELETE_ITEM]:                           OBJ_WEISCHER,

    [actionTypes.ADVERTISEMENTS_DELETE_ITEM]:                       OBJ_ADVERTISEMENT,

    [actionTypes.BRAND_MOVIE_MAPPINGS_DELETE_ITEM]:                 OBJ_ELBENWALD_BRAND_MAPPINGS
}

const updateActions = Object.keys(objTypesByUpdateAction)
const deleteActions = Object.keys(objTypesByDeleteAction)

const pathnameSelector = state => state.getIn([ROUTER, 'location', 'pathname'])


function* setHasUpdates() {
    const pathname = yield select(pathnameSelector)
    const splitArray = yield pathname.slice(1).split('/')

    if(splitArray.length < 1) {
        return yield
    }

    const lastElement = yield splitArray.slice(-1)[0]

    if('edit-item' === lastElement || 'sort-items' === lastElement || 'form' === lastElement || 'elbenwald' === lastElement)  {
        yield put({
            type: actionTypes.HAS_UPDATES_SET_TRUE,
            payload: {
                path: splitArray
            }
        })
    }
}


function* updateObject(request) {
    const { type, payload } = yield request
    const objectType = yield objTypesByUpdateAction[type]

    yield call(setHasUpdates)

    if(OBJ_ELBENWALD_BRAND_MAPPINGS === objectType) {
        yield put({
            type: actionTypes.PROGRAM_UPDATE_ITEM_LOCAL_UPDATE,
            payload: {
                data: payload,
                objectType: objectType
            }
        })
    } else {
        yield put({
            type: actionTypes.PROGRAM_UPDATE_ITEM_UPDATE,
            payload: {
                pk: payload.pk,
                objectType: objectType
            }
        })
    }
}


function* deleteObject(request) {
    const { type, payload } = yield request
    const objectType = yield objTypesByDeleteAction[type]

    yield call(setHasUpdates)

    if(OBJ_ELBENWALD_BRAND_MAPPINGS === objectType) {
        yield put({
            type: actionTypes.PROGRAM_UPDATE_ITEM_LOCAL_DELETE,
            payload: {
                data: payload,
                objectType: objectType
            }
        })
    } else {
        yield put({
            type: actionTypes.PROGRAM_UPDATE_ITEM_DELETE,
            payload: {
                pk: payload.pk,
                objectType: objectType
            }
        })
    }
}


export function* watchUpdateProgram() {
    try {
        yield  takeEvery(updateActions, updateObject)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}


export function* watchDeleteProgram() {
    try {
        yield takeEvery(deleteActions, deleteObject)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}




